import { createFileRoute } from '@tanstack/react-router';

import { SignUpPage, signUpSearchSchema } from '@/pages/sign-up';

export const Route = createFileRoute('/sign-up')({
    validateSearch: signUpSearchSchema,
    component: SignUpPage,
});
